import React, { useEffect, useState } from 'react';
import Admin from '../Admin/Admin';
import classes from './Appointments.module.css';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { Button } from '@mui/material';
import {
  deleteAppointment,
  updateAppointment,
} from '../../../api/services.api';

export default function Appointments() {
  const columns = [
    { field: 'name', headerName: 'Name', width: 170 },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'phone', headerName: 'Phone', width: 170 },
    { field: 'date', headerName: 'Date', width: 150 },
    {
      field: 'note',
      headerName: 'Note',
      width: 200,
      editable: true,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      renderCell: params => (
        <Button
          onClick={() => {
            deleteAppointment(params.row.id)
              .then(res => {
                alert('Succesfully deleted appointment');
                setAppointments(prev =>
                  prev.filter(item => item._id !== params.row.id)
                );
              })
              .catch(err => alert('Error deleting appointment'));
          }}
          variant='contained'
          color='error'
        >
          Delete
        </Button>
      ),
    },
  ];
  const [appointments, setAppointments] = useState();
  const [error, setError] = useState();
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}services/appointments`, {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
      .then(res => setAppointments(res.data))
      .catch(err => setError(err));
  }, []);

  return (
    <Admin>
      <div className={classes.container}>
        <h1>Appointment Requests</h1>
        {appointments && (
          <DataGrid
            processRowUpdate={params => {
              updateAppointment(params);
              alert('edit succesfful');
            }}
            experimentalFeatures={{ newEditingApi: true }}
            sx={{ width: '100%', borderRadius: '0' }}
            rowHeight={100}
            columns={columns}
            rows={appointments.map(item => ({
              id: item._id,
              email: item.email,
              phone: item.phone,
              name: item.name,
              date: item.date,
            }))}
          />
        )}
        {error && <div>{JSON.stringify(error)}</div>}
      </div>
    </Admin>
  );
}
